
import { useEffect, useMemo, useState } from "react";
import { FeePlanShortDetails } from "./FeePlanShortDetails";
import { getData, Postdata, Postdataform } from "../../../API/GlobalApi";
import { useNavigate } from "react-router-dom";
import Notifier from "../../../Utils/notify";
import { reactSelectStyles } from "../../../Utils/selectBoxStyle";
import Select from 'react-select'
import AddFeeHeadModal from "../../../Component/Modals/AddFeeHead";
import ConfirmationModal from "../../../Component/Modals/ConfirmationModal";
import OtpModal from "../../../Component/Modals/DiscountOtpInput";
import { ImposeFeePlanPreview } from "../../../Component/Modals/ImposeFeePlanPreview";
import { generateFeePlanPDF } from "../../../Utils/generatePdfForTemplateSent";


import { v4 as uuidv4 } from "uuid";
import { WaitFeeApprovalsModal } from "../../../Component/Modals/WaitApprovalForFeeTemplate";

const AddStudentWiseFee = () => {




    // State
    const [courseData, setCourseData] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [semesterOptions, setSemesterOptions] = useState([]);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedSemester, setSelectedSemester] = useState(null);
    const [selectedSections, setSelectedSections] = useState([]);
    const [allCourseStudents, setAllCourseStudents] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState([]); // not null

    const [searchTerm, setSearchTerm] = useState("");
    const [showStudents, setShowStudents] = useState(false);

    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);

    const getSessions = async () => {
        const response = await getData("academics/academic-years/")
        const options = response?.map((session) => ({
            value: session.id,
            label: session.name,
            is_current: session.is_current,
        }));

        setSessions(options);

        // Find the default session where is_current is true
        const currentSession = options.find((opt) => opt.is_current);

        if (currentSession) {
            setSelectedSession(currentSession);
        }
    };

    useEffect(() => {
        getSessions();
    }, []);



    // Fetch specialization list whenever selectedSession changes
    useEffect(() => {
        // if (!selectedSession) return;
        // Reset state immediately when session changes

        // setSelectedCourse(null);
        // setSelectedSemester(null);
        // setSelectedSections([]);
        // setSemesterOptions([]);
        // setSectionOptions([]);
        // setStudents([]);
        // setAllCourseStudents([]);
        // setSelectedStudent([]);
        setShowStudents(false);
        const fetchData = async () => {
            // const query = `?academic_year_id=${selectedSession.value}`;
            const res = await getData(`finance/specializations/`);

            if (Array.isArray(res)) {
                setCourseData(res);
                setCourseOptions(res.map((c) => ({ value: c.id, label: c.full_name })));
            }


        };

        fetchData();
    }, []);



    // When course changes → set semesters, collect all students
    // COURSE selection


    useEffect(() => {
        if (!selectedCourse) {
            setSemesterOptions([]);
            setSectionOptions([]);
            setStudents([]);
            setAllCourseStudents([]);
            setSelectedStudent([]);
            setShowStudents(false);
            setSelectedSemester(null);
            setSelectedSections([]);
            return;
        }

        const course = courseData.find(c => c.id === selectedCourse.value);

        if (course?.academic_groups) {
            const semesters = course.academic_groups.map(s => ({ value: s.id, label: s.name }));
            setSemesterOptions(semesters);

            let courseStudents = [];
            course.academic_groups.forEach(semester => {
                semester.lags?.forEach(section => {
                    section.students?.forEach(stu => {
                        courseStudents.push({
                            id: stu.user_id,
                            name: stu.full_name,
                            rollNumber: stu.permanent_registration_number,
                            semester: semester.id,
                            semesterName: semester.name,
                            section: section.id,
                            sectionName: section.name,
                            courseId: course.id,
                            feeSchedules: stu.fee_schedules || []
                        });
                    });
                });
            });

            setAllCourseStudents(courseStudents);
            setStudents(courseStudents);
            setSelectedStudent(courseStudents.map(s => s.id)); // all selected by default
            setShowStudents(false);
            setSelectedSemester(null);
            setSelectedSections([]);
            setSectionOptions([]);
        } else {
            setAllCourseStudents([]);
            setStudents([]);
            setSelectedStudent([]);
            setSemesterOptions([]);
            setSectionOptions([]);
            setShowStudents(false);
            setSelectedSemester(null);
            setSelectedSections([]);
        }
    }, [selectedCourse]);

    // SEMESTER selection
    useEffect(() => {
        if (!selectedSemester) {
            setStudents(allCourseStudents);
            setSectionOptions([]);
            setSelectedSections([]);
            return;
        }

        const semesterId = selectedSemester.value;

        const filteredBySemester = allCourseStudents.filter(stu => stu.semester === semesterId);
        setStudents(filteredBySemester);
        setSelectedStudent(filteredBySemester.map(s => s.id)); // keep all selected

        // Enable section dropdown
        const course = courseData.find(c => c.id === selectedCourse?.value);
        const semesterData = course?.academic_groups.find(s => s.id === semesterId);

        const sections = semesterData?.lags?.map(sec => ({ value: sec.id, label: sec.name })) || [];
        setSectionOptions(sections);
        setSelectedSections([]);
    }, [selectedSemester, allCourseStudents, selectedCourse, courseData]);

    // SECTION selection
    useEffect(() => {
        if (!selectedSections.length) {
            if (selectedSemester) {
                const filteredBySemester = allCourseStudents.filter(stu => stu.semester === selectedSemester.value);
                setStudents(filteredBySemester);
                setSelectedStudent(filteredBySemester.map(s => s.id));
            } else {
                setStudents(allCourseStudents);
                setSelectedStudent(allCourseStudents.map(s => s.id));
            }
            return;
        }

        const sectionIds = selectedSections.map(s => s.value);
        const filteredBySection = allCourseStudents.filter(stu => sectionIds.includes(stu.section));
        setStudents(filteredBySection);
        setSelectedStudent(filteredBySection.map(s => s.id));
    }, [selectedSections, allCourseStudents, selectedSemester]);



    const filteredStudents = useMemo(() => {
        let result = [...allCourseStudents];

        if (selectedCourse) {
            result = result.filter(stu => stu.courseId === Number(selectedCourse.value));
        }
        if (selectedSemester) {
            result = result.filter(stu => stu.semester === Number(selectedSemester.value));
        }
        if (selectedSections?.length) {
            const sectionIds = selectedSections.map(s => s.value);
            result = result.filter(stu => sectionIds.includes(stu.section));
        }

        // // 🔹 Apply Fee Head Filter
        // if (selectedFeeHeads.length > 0) {
        //     result = result.filter(stu =>
        //         (stu.feeSchedules || []).some(fs =>
        //             selectedFeeHeads.includes(Number(fs.fee_type_head_pk))
        //         )
        //     );
        // }

        // 🔹 Apply search filter
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(stu =>
                stu.name?.toLowerCase().includes(term) ||
                stu.rollNumber?.toLowerCase().includes(term) ||
                stu.mobile_number?.toString().includes(term) ||
                stu.email?.toLowerCase().includes(term)
            );
        }

        result.sort((a, b) => a.name.localeCompare(b.name));
        return result;
    }, [
        allCourseStudents,
        selectedCourse,
        selectedSemester,
        selectedSections,

        searchTerm
    ]);

    const [feeRows, setFeeRows] = useState([{ semester: null, feeHead: null, amount: '' }]);
    const [feeHeadOptions, setFeeHeadOptions] = useState([]);

    useEffect(() => {
        setFeeRows(prev =>
            prev.map(row => ({
                ...row,
                fee_type_head_id: "",
                fee_type_head: ""
            }))
        );
    }, [selectedCourse, selectedSemester, selectedSections]);

    const navigate = useNavigate();

    useEffect(() => {
        const getFeeTypes = async () => {
            try {
                const res = await getData('students/get-payment-types/');

                let options = (res?.fee_heads || []).map(t => ({
                    label: t.name,
                    value: t.id
                }));

                // Append special option
                options.push({ label: "+ Add Fee Head", value: "__add__" });

                setFeeHeadOptions(options);
            } catch (err) {
                setFeeHeadOptions([{ label: "+ Add Fee Head", value: "__add__" }]);
            }
        };
        getFeeTypes();
    }, []);


    const [showAddModal, setShowAddModal] = useState(false);
    const [activeRowIndex, setActiveRowIndex] = useState(null);

    const handleFeeHeadChange = (val, idx) => {
        if (val?.value === "__add__") {
            setActiveRowIndex(idx); // store which row to update later
            setShowAddModal(true);
        } else {
            updateFeeRow(idx, "feeHead", val);
        }
    };



    const [newFeeHead, setNewFeeHead] = useState("");
    const handleAddFeeHead = async () => {
        try {
            const res = await Postdata("core/fee-type-heads/", { name: newFeeHead });
            if (res?.id) {
                Notifier.success("Fee Head created successfully");

                const newOption = { label: res.name, value: res.id };

                // ✅ Update options (keep "+ Add Fee Head" at end)
                setFeeHeadOptions(prev => [
                    ...prev.filter(opt => opt.value !== "__add__"),
                    newOption,
                    { label: "+ Add Fee Head", value: "__add__" }
                ]);

                // ✅ Update the correct row with the new Fee Head (so it becomes selected)
                if (activeRowIndex !== null) {
                    updateFeeRow(activeRowIndex, "fee_type_head_id", newOption.value);
                    updateFeeRow(activeRowIndex, "fee_type_head", newOption.label);
                }

                setShowAddModal(false);
                setNewFeeHead("");
            } else {
                let errorMsg = "Failed to create Fee Head";
                if (res && typeof res === "object") {
                    const fieldErrors = Object.entries(res)
                        .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
                        .join("\n");
                    if (fieldErrors) errorMsg = fieldErrors;
                }
                Notifier.error(errorMsg);
            }
        } catch (err) {
            Notifier.error("Something went wrong. Please try again.");
        }
    };


    const toggleAll = (e) => {
        if (e.target.checked) setSelectedStudent(students.map(s => s.id));
        else setSelectedStudent([]);
    };

    const toggleOne = (id) => {
        setSelectedStudent(prev => prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]);
    };

    const addFeeRow = () => setFeeRows(prev => [...prev, { semester: null, feeHead: null, amount: '' }]);

    const updateFeeRow = (index, key, value) => {
        setFeeRows(prev => {
            const copy = [...prev];
            copy[index] = { ...copy[index], [key]: value };
            return copy;
        });
    };

    const removeFeeRow = (index) => setFeeRows(prev => prev.filter((_, i) => i !== index));

    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [previewData, setPreviewData] = useState(null)

    const buildFeePlanPayload = () => {

        const visibleStudents = filteredStudents;

        // 2️⃣ take only selected students that are part of visible
        const studentIdsToSend = selectedStudent.filter(id =>
            visibleStudents.some(stu => stu.id === id)
        );
        const noStudentsExist = visibleStudents.length === 0;


        // 3️⃣ decide plan mode
        const isAllSelected =
            visibleStudents.length > 0 &&
            studentIdsToSend.length === visibleStudents.length;

        // const planMode = isAllSelected ? "course" : "individual";
        const planMode = (noStudentsExist || isAllSelected)
            ? "course"
            : "individual";


        let payload;
        if (planMode === "course") {
            payload = {
                academic_year_id: selectedSession?.value,
                specialization_id: selectedCourse?.value || null,
                semester_id: selectedSemester?.value || null,
                payments: feeRows.map(r => ({
                    fee_head_id: r.fee_type_head_id || null,
                    amount: Number(r.amount) || 0,
                })),
                employee_ids: selectedEmployeeIds.join(","),
            };
        } else {
            payload = {
                plan_mode: "individual",
                academic_year_id: selectedSession?.value,
                student_ids: studentIdsToSend.join(","),
                payments: feeRows.map(r => ({
                    academic_group_id: selectedSemester?.value || null,
                    amount: Number(r.amount) || 0,
                    fee_head_id: r.fee_type_head_id || null,
                })),
                employee_ids: selectedEmployeeIds.join(","),
            };
        }


        return { payload, planMode, studentIdsToSend };
    };



    const handleBeforeSubmit = () => {
        const { payload, planMode, studentIdsToSend } = buildFeePlanPayload();

        // Pass data to preview modal
        setPreviewData({
            planMode,
            payload,
            studentIdsToSend,
            selectedSections,
            selectedSession,
            selectedCourse,
            selectedSemester,
            students,
            selectedStudent,
            feeRows,

        });

        setPreviewOpen(true);
    };

    const handleConfirmFeePlan = async () => {
        setIsSubmitting(true);

        try {
            await handleSubmit();
            setConfirmationModalOpen(false);
        } catch (error) {
            console.error("❌ Error confirming fee plan:", error);
            Notifier.error("Failed to impose fee. Please try again.");

        } finally {
            setIsSubmitting(false);
        }
    };

    const [otpModal, setOtpModal] = useState(false)
    const [helpdeskperson, setHelpDeskPerson] = useState([]);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]); // now an array


    const gethelpdeskPerson = async () => {
        const url = "finance/course-fee-plans/authorized-employees/?type=impose";
        const response = await getData(url);
        setHelpDeskPerson(response?.authorized_employees)

    }
    useEffect(() => {

        gethelpdeskPerson()
    }, [])
    const [specializationSubmitResponse, setSpecializationSubmitResponse] = useState()

    const handleOtpConfirm = async (otpCode) => {
        try {
            let url = "";
            let payload = {};

            if (specializationSubmitResponse?.plan_mode === "course") {

                url = "finance/course-fee-plans/verify/";
                payload = {
                    specialization_id: selectedCourse?.value || null,
                    unique_id: specializationSubmitResponse?.unique_id,
                    otp: otpCode,
                };
            } else {

                url = "finance/fee-schedules/verify-and-create/";
                payload = {
                    unique_id: specializationSubmitResponse?.unique_id,
                    otp: otpCode,
                };
            }
            const response = await Postdata(url, payload);
            if (response?.error) {
                Notifier.error(response?.error || "OTP verification failed");
            } else {
                Notifier.success("Fee Imposed Successfully!");
                setOtpModal(false);
                navigate(-1, { state: { refreshKey: Date.now() } });
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };

    const handleOtpCancel = () => {
        setSelectedCourse(null)
        setOtpModal(false);
        setSelectedEmployeeIds([])
        navigate(-1)

    }


    const handleOtpResend = async () => {
        try {
            let url = "";
            let payload = {};

            if (specializationSubmitResponse?.plan_mode === "course") {
                // 👉 Course mode resend
                url = "finance/course-fee-plans/resend-verification-otp/";
                payload = {
                    unique_id: specializationSubmitResponse?.unique_id,
                    specialization_id: selectedCourse?.value || null,
                    employee_ids: selectedEmployeeIds.join(","),
                };
            } else {
                // 👉 Individual mode resend
                url = "finance/fee-schedules/resend-otp/";
                payload = {
                    unique_id: specializationSubmitResponse?.unique_id,
                    employee_ids: selectedEmployeeIds.join(","),
                };
            }

            const response = await Postdata(url, payload);

            if (!response?.error) {
                if (specializationSubmitResponse?.plan_mode === "course") {
                    // course API gives plain OTP string
                    setSpecializationSubmitResponse((prev) => ({
                        ...prev,
                        otp: response?.otps || null,
                        unique_id: response?.unique_id || prev?.unique_id,
                        plan_mode: prev?.plan_mode,
                    }));
                } else {
                    // individual API gives OTP array
                    setSpecializationSubmitResponse({ otp: response.otps, unique_id: response.pending_plan_id })
                }

                Notifier.success(response?.message || "OTP resent successfully!");
            } else {
                Notifier.error(response?.error || "Failed to resent OTP.");
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };


    const handleCancelFeePlan = () => {
        if (!isSubmitting) {
            setConfirmationModalOpen(false);
        }

    };
    // const isFormValid =
    //     feeRows.length > 0 &&
    //     feeRows.every(row =>
    //         // row.semester?.value &&                      
    //         row.fee_type_head_id &&
    //         row.amount?.trim() !== "" &&
    //         !isNaN(row.amount) && Number(row.amount) > 0 // valid positive number
    //     ) &&
    //     selectedStudent.length > 0 && // at least one student selected
    //     selectedEmployeeIds.length > 0;


    const hasVisibleStudents = filteredStudents.length > 0;

    const isCourseMode =
        !hasVisibleStudents ||
        (selectedStudent.length === filteredStudents.length);

    const isFormValid =
        feeRows.length > 0 &&
        feeRows.every(row =>
            row.fee_type_head_id &&
            row.amount?.trim() !== "" &&
            !isNaN(row.amount) &&
            Number(row.amount) > 0
        ) &&
        selectedEmployeeIds.length > 0 &&
        (
            isCourseMode || selectedStudent.length > 0
        );





    const handleCancel = () => {
        setSelectedCourse('')
        setSelectedStudent('');
        setSelectedSemester('')
        setSelectedSections('')
        setSelectedStudent('')

    };


    const [selectedFeePlan, setSelectedFeePlan] = useState(null);


    const [showWaittingModal, setShowWaitingModal] = useState(false)


    const handleSubmit = async () => {


        try {
            // Generate UUID filename first
            const uniqueFileName = uuidv4().replace(/-/g, "").slice(0, 20);
            const pdfBlob = generateFeePlanPDF(previewData);
            const { payload, planMode } = buildFeePlanPayload();
            // Define URLs dynamically based on plan mode
            const courseWiseUrl = `${process.env.REACT_APP_WINDOW_BASEURL2}fee/impose-aprrovals-course-wise/${uniqueFileName}`;
            const studentWiseUrl = `${process.env.REACT_APP_WINDOW_BASEURL2}fee/impose-aprrovals-student-wise/${uniqueFileName}`;
            payload.approval_url = planMode === "course" ? courseWiseUrl : studentWiseUrl;
            payload.document_uuid = uniqueFileName.split("/").pop();
            const formData = new FormData();
            formData.append("document_url", pdfBlob, `${uniqueFileName}.pdf`);
            Object.entries(payload).forEach(([key, value]) => {
                // If value is an object or array, stringify it
                if (typeof value === "object" && value !== null) {
                    formData.append(key, JSON.stringify(value));
                } else {
                    formData.append(key, value);
                }
            });
            const endpoint =
                planMode === "course"
                    ? "finance/course-fee-plans/new/create/"
                    : "finance/fee-schedules/";

            const response = await Postdataform(endpoint, formData);

            if (response.error) {


                const apiError =
                    Array.isArray(response.details) && response.details.length > 0
                        ? response.details[0]
                        : response.error;

                const cleanedError = apiError
                    .replace(/^\[|\]$/g, "")
                    .replace(/['"]+/g, "")
                    .trim();

                Notifier.error(cleanedError);

                return;   // ⛔ Stop here — do NOT throw again
            } else {
                if (response?.unique_id) {
                    setSpecializationSubmitResponse({
                        otp: response.otps,
                        unique_id: response?.unique_id || response?.pending_plan_id,
                        plan_mode: planMode,
                    });
                    setShowWaitingModal(true)
                    setSelectedFeePlan(response?.purchase_order);
                }

            }
        } catch (error) {
            console.error("Error submitting fee plan:", error);
            // Notifier.error(error);
            // throw error;
        }
    };

    return (
        <>
            <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
            }}> <div style={{ flexShrink: 0, padding: "0 12px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {/* Left side: SVG + heading */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <button
                                onClick={() => navigate(-1)}
                                style={{ background: "transparent", border: "none", cursor: "pointer", padding: 0 }}
                                title="Go back"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="32"
                                    height="32"
                                    fill="none"
                                    stroke="#7F56DA"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <line x1="19" y1="12" x2="5" y2="12"></line>
                                    <polyline points="12 19 5 12 12 5"></polyline>
                                </svg>
                            </button>
                            <h2 className='main-heading' style={{ margin: 0, color: "#7F56DA" }}>Add Impose Fee Plan</h2>
                        </div>
{/* 
                        <div>
                            <label className="form-labell">Academic Year</label>
                            <Select
                                options={sessions}
                                value={selectedSession}
                                onChange={opt => setSelectedSession(opt)}
                                styles={reactSelectStyles}
                                placeholder="Select Session"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                isDisabled={true}
                            />

                        </div> */}
                    </div>
                </div>


                <div
                    className='scheduleconainer'
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        overflowX: "hidden",
                        minHeight: 0,
                        padding: "12px",
                        paddingBottom: '30px',
                        scrollbarGutter: "stable",
                    }}>
                    <div className='col-md-12'>
                        <div className="row mt-3 d-flex justify-content-start">

                            {/* <div className="col-md-3">
                            <label className="form-labell"> Academic Year</label>
                            <Select
                                options={sessions}
                                value={selectedSession}
                                onChange={opt => setSelectedSession(opt)}
                                styles={reactSelectStyles}
                                placeholder="Select Session"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                            />

                        </div> */}


                            <div className="col-md-4">
                                <label className="form-labell">Course</label>
                                <Select
                                    value={selectedCourse}
                                    onChange={(opt) => setSelectedCourse(opt)}
                                    options={courseOptions}
                                    styles={reactSelectStyles}
                                    placeholder="Select Course"
                                    isClearable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-labell">Semester</label>
                                <Select
                                    value={selectedSemester || null}
                                    onChange={(option) => setSelectedSemester(option || null)}
                                    options={semesterOptions}
                                    styles={reactSelectStyles}
                                    placeholder="Select Semester"
                                    isMulti={false}
                                    isDisabled={!semesterOptions.length}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-labell">Section</label>
                                <Select
                                    value={selectedSections}
                                    onChange={(opts) => setSelectedSections(opts || [])}
                                    options={sectionOptions}
                                    styles={reactSelectStyles}
                                    placeholder="Select Section(s)"
                                    isMulti
                                    isDisabled={!sectionOptions.length}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />

                            </div>
                        </div>
                        <div className='  '>
                            {!selectedCourse ? (
                                <div
                                    className="col-12 d-flex flex-column align-items-center justify-content-center mt-5 sections"
                                    style={{ minHeight: 420, textAlign: 'center', color: '#6c757d' }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="80"
                                        height="80"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#6c757d"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M21 21l-4.35-4.35"></path>
                                        <circle cx="10" cy="10" r="7"></circle>
                                        <line x1="14" y1="10" x2="14" y2="10"></line>
                                    </svg>
                                    <p className="mt-3" style={{ fontSize: '18px', fontWeight: 500 }}>
                                        No records found
                                    </p>
                                    <p className="text-muted" style={{ fontSize: '14px' }}>
                                        Please select a course to view students.
                                    </p>
                                </div>
                            ) : (
                                <div className="row mt-2 d-flex justify-content-start  mt-5 sections">
                                    <div className="col-md-12 d-flex align-items-center gap-2 mt-3 mb-3 justify-content-between">
                                        <div className="form-check form-switch custom-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                style={{ cursor: 'pointer', zIndex: 1 }}
                                                checked={showStudents} // controlled by state
                                                onChange={() => setShowStudents(prev => !prev)} // toggle
                                                title="Enabel for student wise created fee plan"
                                            />
                                            <label className="form-check-label">
                                                {showStudents ? "Hide student list" : "Show student List"}

                                            </label>
                                        </div>
                                        <span>Total Students :{selectedStudent?.length}</span>
                                    </div>


                                    {showStudents && (
                                        <div className="col-md-12">
                                            <div className="row mt-4 align-items-center">
                                                <div className="col-md-6 d-flex align-items-center">
                                                    <h5 className="mb-0">Select Students</h5>
                                                </div>
                                                <div className="col-md-6 d-flex align-items-center justify-content-end">
                                                    <span className="text-muted small">
                                                        {selectedStudent?.length} / {students?.length} selected
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="feePlanTableContainer mt-1" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                <table className="table table-bordered mt-2 feeplantables">
                                                    <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                                                        <tr>
                                                            <th>
                                                                <input
                                                                    type="checkbox"
                                                                    disabled={students.length === 0}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked) setSelectedStudent(students.map(s => s.id));
                                                                        else setSelectedStudent([]);
                                                                    }}
                                                                    checked={students.length > 0 && selectedStudent.length === students.length}
                                                                />


                                                            </th>
                                                            <th style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                                                Student Name (Registration No.)
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Search students by name,registraion number,mobile number.."
                                                                    value={searchTerm}
                                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                                    style={{ maxWidth: '480px', height: '30px', fontSize: '14px' }}
                                                                />
                                                            </th>
                                                            <th>Course</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredStudents.length > 0 ? (
                                                            filteredStudents.map(stu => (
                                                                <tr key={stu.id}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={Array.isArray(selectedStudent) && selectedStudent.includes(stu.id)}
                                                                            onChange={() => {
                                                                                setSelectedStudent(prev =>
                                                                                    Array.isArray(prev)
                                                                                        ? prev.includes(stu.id)
                                                                                            ? prev.filter(id => id !== stu.id)
                                                                                            : [...prev, stu.id]
                                                                                        : [stu.id]
                                                                                );
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>{stu.name} ({stu.rollNumber})</td>
                                                                    <td>{selectedCourse?.label || "—"}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center text-muted">
                                                                    No student details found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>


                                        </div>)}
                                </div>
                            )}
                        </div>
                        <div className="row mt-2 d-flex justify-content-start">
                            <div className="col-md-12">
                                {selectedCourse && (
                                    <>
                                        {/* Title row */}
                                        <div className="row mt-1 align-items-center justify-content-center">
                                            <div className="col-12 text-start">
                                                <h5 className="mb-1">Fee Plan Details</h5>
                                            </div>
                                        </div>
                                        {/* Fee rows */}
                                        {feeRows.map((row, index) => (
                                            <>
                                                <div className="row mb-2 mt-1 align-items-center" key={index}>
                                                    {/* <div className="col-md-4">
                                                    <Select
                                                        options={semesterOptions}
                                                        value={row.semester}
                                                        onChange={(val) => updateFeeRow(index, "semester", val)}
                                                        placeholder="Semester"
                                                        styles={reactSelectStyles}
                                                        isClearable
                                                        menuPlacement="auto" // auto chooses 'top' or 'bottom' based on space
                                                        menuPosition="absolute" // ensures positioning works as expected

                                                    />
                                                </div> */}
                                                    <div className="col-md-4 d-flex align-items-center gap-2">
                                                        <div style={{ flexGrow: 1 }}>
                                                            <Select
                                                                options={feeHeadOptions}
                                                                value={
                                                                    feeHeadOptions.find(opt =>
                                                                        opt.value === row.fee_type_head_id
                                                                    ) || null
                                                                }

                                                                onChange={(val) => {
                                                                    if (val?.value === "__add__") {
                                                                        setActiveRowIndex(index);
                                                                        setShowAddModal(true);
                                                                    } else {
                                                                        updateFeeRow(index, "fee_type_head_id", val?.value || "");
                                                                        updateFeeRow(index, "fee_type_head", val?.label || "");
                                                                    }
                                                                }}

                                                                placeholder="Select Fee Head"
                                                                styles={{
                                                                    ...reactSelectStyles,
                                                                    option: (base, state) => ({
                                                                        ...reactSelectStyles.option(base, state),
                                                                        ...(state.data?.value === "__add__" && {
                                                                            color: '#7F56DA',
                                                                            fontWeight: 'bold',
                                                                            borderTop: '1px solid #ccc',
                                                                            cursor: 'pointer',
                                                                            backgroundColor: state.isFocused ? '#f4eefe' : 'white'
                                                                        })
                                                                    }),
                                                                    menuPortal: base => ({ ...base, zIndex: 99 })
                                                                }}
                                                                isClearable
                                                                // menuPortalTarget={document.body}
                                                                menuPlacement="auto"
                                                                menuPosition="absolute"
                                                                filterOption={(option, inputValue) => {
                                                                    if (option.value === "__add__") return true;
                                                                    return option.label.toLowerCase().includes(inputValue.toLowerCase());
                                                                }}
                                                                noOptionsMessage={() => "+ Add Fee Head"}
                                                            />

                                                        </div>

                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="d-flex align-items-center">
                                                            <input
                                                                type="text"
                                                                className="form-control me-2"
                                                                placeholder="Amount"
                                                                value={row.amount}
                                                                onChange={(e) => {
                                                                    let value = e.target.value;
                                                                    // Allow only up to 7 digits before decimal & 2 after
                                                                    if (/^\d{0,7}(\.\d{0,2})?$/.test(value)) {
                                                                        updateFeeRow(index, "amount", value);
                                                                    }
                                                                }}
                                                                style={{ height: "45px" }}
                                                                onKeyDown={(e) => {
                                                                    if (["e", "E", "+", "-", "/", "*", "_"].includes(e.key)) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                            />

                                                            {feeRows.length > 1 && (
                                                                <button
                                                                    onClick={() => removeFeeRow(index)}
                                                                    style={{ background: "none", border: "none", padding: 0 }}
                                                                    title="Remove"
                                                                >
                                                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                                                                        <path d="M3 6H5H21" stroke="red" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M8 6V4C8 3.44772 8.44771 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V6H19Z" stroke="red" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M10 11V17" stroke="red" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M14 11V17" stroke="red" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </button>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                        {/* Footer row */}
                                        <div className="row mb-2 mt-3 align-items-center">
                                            <div className="col-md-6">
                                                <button
                                                    type="button"
                                                    className="btn mt-2"
                                                    onClick={addFeeRow}
                                                    style={{ border: "none", color: "#7F56DA" }}
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 22 23" fill="none">
                                                        <path
                                                            d="M20.4286 13.3537H12.5714V21.2108C12.5714 21.6276 12.4059 22.0273 12.1112 22.322C11.8165 22.6167 11.4168 22.7822 11 22.7822C10.5832 22.7822 10.1835 22.6167 9.88883 22.322C9.59413 22.0273 9.42857 21.6276 9.42857 21.2108V13.3537H1.57143C1.15466 13.3537 0.754961 13.1881 0.460261 12.8934C0.165561 12.5987 0 12.199 0 11.7822C0 11.3655 0.165561 10.9658 0.460261 10.6711C0.754961 10.3764 1.15466 10.2108 1.57143 10.2108H9.42857V2.35366C9.42857 1.93689 9.59413 1.53719 9.88883 1.24249C10.1835 0.947787 10.5832 0.782227 11 0.782227C11.4168 0.782227 11.8165 0.947787 12.1112 1.24249C12.4059 1.53719 12.5714 1.93689 12.5714 2.35366V10.2108H20.4286C20.8453 10.2108 21.245 10.3764 21.5397 10.6711C21.8344 10.9658 22 11.3655 22 11.7822C22 12.199 21.8344 12.5987 21.5397 12.8934C21.245 13.1881 20.8453 13.3537 20.4286 13.3537Z"
                                                            fill="currentColor"
                                                        />
                                                    </svg>
                                                    <span className="ms-2">Add More</span>
                                                </button>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <label className="form-labell mb-2">
                                                        Authorised Person<span className="astrisk">*</span>
                                                    </label>

                                                    <Select
                                                        classNamePrefix="select"
                                                        isSearchable
                                                        isMulti                        // <-- enable multi-select
                                                        name="employee"
                                                        options={helpdeskperson?.map(emp => ({
                                                            value: emp.id,
                                                            label: emp.name,
                                                        }))}
                                                        placeholder="-- Select Employee --"
                                                        value={helpdeskperson
                                                            ?.map(emp => ({
                                                                value: emp.id,
                                                                label: emp.name,
                                                            }))
                                                            .filter(option => selectedEmployeeIds?.includes(option.value))}  // <-- filter selected
                                                        onChange={(selected) => setSelectedEmployeeIds(selected?.map(s => s.value) || [])} // store array of ids
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...reactSelectStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9 }), // 👈 this will override
                                                        }}

                                                        menuPlacement="auto"
                                                    // menuPosition="absolute"
                                                    />

                                                </div>

                                            </div>
                                            <div className="row d-flex justify-content-end">
                                                <div className="col-md-6 d-flex justify-content-end gap-3">
                                                    <button
                                                        onClick={handleCancel}
                                                        style={{
                                                            backgroundColor: '#f44336',
                                                            color: '#fff',
                                                            border: 'none',
                                                            padding: '4px 20px',   // reduce vertical padding
                                                            lineHeight: '20px',    // control button text height
                                                            borderRadius: '6px',
                                                            fontWeight: '500',
                                                            cursor: 'pointer',
                                                            transition: 'background-color 0.3s ease'
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>

                                                    <button className="add-btn" onClick={handleBeforeSubmit}
                                                        disabled={!isFormValid}   // ✅ disable when not valid
                                                        style={{
                                                            opacity: !isFormValid ? 0.6 : 1,
                                                            cursor: !isFormValid ? "not-allowed" : "pointer",
                                                            background: !isFormValid ? '#d3d3d3' : '#7F56DA'
                                                        }}>
                                                        Impose Fee
                                                    </button>
                                                </div>
                                            </div>



                                        </div>
                                    </>
                                )}
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <AddFeeHeadModal
                isOpen={showAddModal}
                onClose={() => setShowAddModal(false)}
                onSubmit={handleAddFeeHead}
                setNewFeeHead={setNewFeeHead}
                newFeeHead={newFeeHead}
            />
            <ConfirmationModal
                isOpen={confirmationModalOpen}
                title="Confirm Submission"
                message="Are you sure you want to impose this fee?"
                onConfirm={handleConfirmFeePlan}
                isSubmitting={isSubmitting}
                onCancel={handleCancelFeePlan}
                showCheckbox={false}
            />

            <OtpModal
                title="Confirmation!"
                heading="Please enter 6 digit OTP to confirm the fee imposition"
                isOpen={otpModal}
                onConfirm={handleOtpConfirm}
                onCancel={handleOtpCancel}
                onResend={handleOtpResend}
                studentResponse={specializationSubmitResponse}
            />

            <ImposeFeePlanPreview
                isOpen={previewOpen}
                onClose={() => setPreviewOpen(false)}
                planMode={previewData?.planMode}
                payload={previewData?.payload}
                selectedCourse={selectedCourse}
                selectedSemester={selectedSemester}
                students={students}
                selectedStudent={selectedStudent}
                selectedSessionName={selectedSession?.label || ""}
                feeRows={feeRows}
                onContinue={() => {
                    setPreviewOpen(false);
                    setConfirmationModalOpen(true);
                }}
            />



            <WaitFeeApprovalsModal isOpen={showWaittingModal}
                feePlanId={specializationSubmitResponse?.unique_id}
                onClose={() => {
                    setShowWaitingModal(false)
                    navigate(-1)
                }} />

        </>
    )
}

export default AddStudentWiseFee